import { useAppContext } from '../../context/AppContext';
import { initialize } from '../../services';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect } from 'react';

const stripePromise = loadStripe('pk_live_51LPR7JL8P0tENnG7IE3FU0zjfahC5bJ816c9T8rfQGZW1RARYExQLmJxypzMiyHLVjwDwpEWk9vHE6e3ZqLOSOcE000uvageSK');

export const Checkout = ({ plan }) => {
  const { base_url, token } = useAppContext();

  useEffect(() => {
    const initializeStripe = async () => {
      const stripe = await stripePromise;
      initialize(base_url, stripe, token, plan);
    };
    initializeStripe();
  }, [base_url, token, plan]);

  return (
    <div>
      <div className="step-header">
        <h2>Checkout</h2>
        <p>Complete your subscription to finish onboarding.</p>
      </div>
      <div id="checkout" />
    </div>
  );
};
